import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import { RootState, useAppSelector } from '../../../store';
import { INavigationTip } from '../../../backoffice/types/navigationTips';

export type backofficeNavigationTipsState = {
    navigationTips: INavigationTip[];
};

const initialState: backofficeNavigationTipsState = {
    navigationTips: [],
};

export const backofficeNavigationTipsSlice = createSlice({
    name: 'backofficeNavigationTips',
    initialState,
    reducers: {
        setBackofficeNavigationTips: (state, action: PayloadAction<INavigationTip[]>) => {
            state.navigationTips = action.payload;
        },
    },
});

export const { setBackofficeNavigationTips } = backofficeNavigationTipsSlice.actions;
export const getBackofficeNavigationTipsState = (state: RootState) => state.backofficeNavigationTips;
export const useBackofficeNavigationTipsState = () => useAppSelector(getBackofficeNavigationTipsState);

export default backofficeNavigationTipsSlice.reducer; 